import { ChangeDetectionStrategy, Component, inject, input, linkedSignal, output, signal } from '@angular/core';
import { chooseFn, ModalOption } from '@softline/ui-core';
import { OptionLabelPipe } from './option-label.pipe';
import { NgTemplateOutlet } from '@angular/common';
import { QueryBarItemComponent } from '../../query-bar/query-bar-item/query-bar-item.component';

@Component({
  selector: 'soft-option-filter',
  imports: [
    QueryBarItemComponent,
    OptionLabelPipe,
  ],
  templateUrl: './option-filter.component.html',
  styleUrl: './option-filter.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionFilterComponent<T extends string | number | object | null | undefined> {
  choose = chooseFn();

  title = input.required<string>();
  icon = input.required<string>();
  options = input<ModalOption<T>[]>([]);
  valueInput = input<T | null>(null, {alias: 'value'});
  clearable = input(true);
  valueChange = output<T | null>();

  value = linkedSignal(() => this.valueInput());

  async onClick() {
    const result = await this.choose<T>({
      title: this.title(),
      options: this.options()
    })
    if(result === 'DISMISSED')
      return;
    this.valueChange.emit(result);
  }

  async onClear() {
    this.value.set(null);
    this.valueChange.emit(null);
  }
}
